export const freedomConstants = {
  APP_ID: 2
};

export const freedomUserType = {
  Customer: 1,
  Distributor: 2,
  Friend: 3,
  Employee: 4,
  Trader: 5,
  CTraderUser: 6,
  SignalUser: 7
};

export const freedomUserSubType = {
  NoTrader: null,
  Trader: 1,
  LeadTrader: 2,
  ManagerTrader: 3,
  CTrader: 4,
  SignalUser: 5,
  CTrader_SignalUser: 6,
  Trader_CTrader: 7,
  LeadTrader_CTrader: 8,
  ManagerTrader_CTrader: 9,
  Trader_SignalUser: 10,
  LeadTrader_SignalUser: 11,
  ManagerTrader_SignalUser: 12,
  Trader_CTrader_SignalUser: 13,
  LeadTrader_CTrader_SignalUser: 14,
  ManagerTrader_CTrader_SignalUser: 15
};

export const freedomLanguage = {
  english: 1
};

export const platformTypeId = {
  Email: 1,
  WhatsApp: 2,
  SMS: 3,
  AppNotification: 4
};

export const inviteStatus = {
  Pending: 1,
  Onboarding: 2,
  Completed: 3,
  ResendMessage: 4,
  Expire: 5,
  PendingInvestorToAffiliate: 6,
  LegNotSet: 7,
  CompanyApprovalPendingFromComplaince: 8,
  traderToAffiliate: 10,
  traderToInvestor: 11
};

/**
 * template status starts
 */
export const invitationEmailTemplates = {
  investorTemplateStart: 1,
  investorTemplateEnd: 5,
  affiliateTemplateStart: 6,
  affiliateTemplateEnd: 10,
  investorToTraderStart: 21,
  investorToTraderEnd: 25,
  affiliateToTraderStart: 16,
  affiliateToTraderEnd: 20
};

export const InvitedByPlatformType = {
  FreedomWebPortal: 1,
  LandingPages: 2
};

export const parentUserLeg = {
  Auto: 0,
  Left: 1,
  Right: 2
};

export const freedomTheme = {
  Light: 'L',
  Dark: 'D'
};

export const mobileLength = {
  Min: 6,
  Max: 15
};

// Payment OTP Type for CreditCard and BankInfo
export const paymentOTPType = {
  CreditCard: 1,
  BankInfo: 2,
  withdrawAmount: 4,
  account: 5,
  passwordChange: 6,
  pendingPayments: 7
};

export const approvalActivities = {
  cashWithdraw: 1
};

/// Payment Satus for OTP Genrate, Validate and Resend
export const paymentOTPStatus = {
  Genrate: 1,
  Validate: 2,
  Resend: 3
};

export const InvesterType = {
  invester: 1,
  pendingInvester: 2
};

export const AffiliateType = {
  Firstline: 1,
  ManageAffilates: 2,
  Pending: 3,
  Downline: 4
};
// export const InvestmentPlanType = {
//   Basic: 1,
//   Advance: 2,
//   Pro: 3,
//   Supreme: 4,
//   Elite: 5
// };

export const GraphPeriod = {
  Week: 1,
  Month: 4,
  Year: 2
};

export const GraphType = {
  affiliate: 'affiliate',
  customer: 'customer'
};

/**
 * transaction fee for adding and removing amount to the system
 */
export const transactionFee = {
  creditCardDeposit: 2,
  cryptoCurrencyDeposit: 2,
  bankAccountDeposit: 2,
  FreedomDebitCardDeposit: 2,
  /**withdraw */
  creditCardWithdraw: 2,
  cryptoCurrencyWithdraw: 2,
  bankAccountWithdraw: 5,
  FreedomDebitWithdraw: 2,
  FreedomInternalAccount: 2
};

/**
 * Earning and Expense Module Status
 */

export const earningModuleStatus = {
  Inactive: 0,
  Active: 1,
  Settled: 2,
  Pending: 3,
  Postponed: 4,
  Cancelled: 5,
  Expired: 6,
  Historic: 7,
  Flushed: 8,
  All: 99
};
export const suspendedBinaryPoint = {
  All: 99,
  Leftlegside: 1,
  Rightlegside: 2,
  Investorpoints: 3,
  Affiliatespoints: 4
};

export const earningSummaryStatusType = {
  All: 99,
  Type: 'Type',
  Paycircle: 'Paycircle',
  PayoutDate: 'PayoutDate'
};

export const loggingSticker = {
  TermAndConditionDisclaimer: 1,
  Login: 2,
  Logout: 3,
  PageView: 4
};

//pagination skip count
export const countSkip = 250;

////////////////////////////////////
export const EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'+^_`{}~-]+(?:\.[a-zA-Z0-9!#$%&'+^_`{}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

export const NAME_REGEX = /^[a-zA-Z\u4E00-\u9FFFæøåÆØÅ\s]*$/;
// export const NAME_REGEX = /^[ a-zA-Z\-’]+$/;
// export const YEAR_REGEX = /^([1][9]\d\d|2[0-9][0-0][0-3])$/;
export const NUMBER_REGEX = /^\d*\.?\d*$/;
export const AlphaNumeric_REGEX = /^[A-Za-z0-9]+$/;
export const SpecialAlphaNumeric_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]+$/;

///TimeOutMinute//////
export const timeOutMinute = 30;

/**
 * Credit card constant section
 */
export const paymentMethodconstant = {
  card: 'Card',
  bank: 'Bank',
  addBank: 'Add Bank',
  addCard: 'Add Card',
  primaryMethod: 'Primary Method',
  internalAccount: 'Internal Account'
};

/**
 * Account Type
 */

export const accountType = {
  standard: 1,
  silver: 2,
  gold: 3,
  platinum: 4,
  exclusive: 9,
  vip: 10,
  unknown: 1000
};

/**
 * Payment Account Type
 */
export const paymentAccountType = {
  internalAccount: 1,
  creditCardAccount: 2,
  bankAccount: 4
};

/**
 * Order Type
 */

export const orderTypes = {
  deposit: 1,
  withdraw: 2,
  account: 3,
  product: 4,
  voucher: 5,
  annualSubscriptionFee: 8,
  pendingInvoice: 9,
  companyDocumentVerivicationFee: 11,
  unknown: 1000
};

export const usersProfieType = {
  Individual: 1,
  Company: 2
};

export const documentTypes = {
  Selfie: 1,
  CNIC: 2,
  residentCard: 3,
  utilityBill: 4
};

export const withDrawOption = {
  bank: 'Bank Account',
  card: 'Credit Card',
  crypto: 'Crypto'
};
export const tradingStatus = {
  Idle: 0,
  Active: 1,
  Stopped: 2,
  Paused: 3,
  PaymentBlocked: 4,
  TradingBlocked: 5,
  IdleToActive: 6,
  Delink: 7,
  Authorization_in_progress: 8,
  emergencyStop: 9,
  NOChange: 10,
  productTrialExpired: 16,
  demoTrialExpired: 17
};
export const graphGrowthAndAccumulateDropDown = [
  {
    id: 0,
    Name: 'Growth',
    Value: 0
  },
  {
    id: 1,
    Name: 'Accumulate',
    Value: 1
  }
];

export const typesOfCreditCard = {
  visa: 'visa',
  master: 'mastercard'
};

export const featureTypes = {
  pinModuleToBottomBar: 1,
  pinLiveTradeHeaders: 2,
  pinTradeHistoryHeaders: 3
};

export const FreedomTradingStatus = {
  Active: 1,
  Delinked: 2,
  TradingUnauthorized: 3,
  TokenExpired: 4
};

export const clientLoginAccessLevel = {
  readOnly: 1,
  writeOnly: 2
};

export const reInvestStatus = {
  Manual: 1,
  Automatic: 2
};

// Product overview and product selection screen

export const productScreenId = {
  productOverview: 1,
  productSelection: 2,
  productSettingsDashboard: 3
};

/**
 * product type id
 */

export const productTypeId = {
  All: 0,
  universal: 1,
  custom: 2
};

export const tradingSource = {
  Bot: 1,
  Trader: 2,
  Signal: 3
};

export const productTabs = {
  Live: 0,
  History: 1
}

export const imagePlaceholder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAMFBMVEXx8/XCy9K/yND09vfw8vTP1tzp7O/i5ure4+fO1dvJ0dfT2d/EzNPt7/Lb4OXo6+4FeM7UAAAFL0lEQVR4nO2c24KrIAxFLdha7///t0dxOlWDSiAKztnrbR4G6SoJBKHZA6zJYncgQeCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ocEKBEwqcUOCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ot3Oi1KMq64FnWTVq+EueWzlRquqKVn/J+/ezEfdyHydKPYtc62yF1m1Xymq5ixPVdDnx8eslf1eCVu7hRFXFppAfLW39kNJyByeqOTJirGTvRsbKDZyozsHIpKUQsZK8E1Vu55GTrKTuRL0ZRoyVLviZaTtRVctUMuaVOnCoJO1E1WwjxsorbGZO2Qk7br5WuhApKTvpfZWMy5WAoZKuk6b1NhI4VJJ10uRBSsas0ng+OlUnVaARw9NvqCTqRERJpt9eUtJ0IqPEN36SdNIIKRnIPeafFJ0Ep9c5mr+qTdFJ2CRMpLAn5fScqJeokrFWZkoRdaImwtpw2T9iSnnxuiDoRFXda6hK28JzWTA14ryBxKFlTT9iTlT1W57o3Lta96yED8krRieknCw/DDuEP1TnKBlgzMlCTtZDXr+8pIjOwitK5x7JOKFD3mukiE85ix45S5FxYll46prdiv8ekpsU19wv4kS9LV1ouQPlrPzKliIzTuw9YDYiVfgFSxFx8rR+wcyMomSX9HYpTjlFwonqrB3gBc/JyYQjRcRJYe8Ay4l9rMlLcVi8iTjp7Y/nOBHcMjngWEoi4+TUlcmKw9rnxHzCWMqeU/ltkB9JEZl3SusnYmwQn1fm2GgPeiOzZrM9WZfu/3/BNDznYATLOLENffep+JppeMZBMSZUF9N6ljFM7KF3qpTduBZyQj4W53XTiRsEm1L2dr2k9k9W9Rtjq2BrJj9Zyk7pI7bP9lw8kfH+4KIFLGF77Sa3R90Un0POvHNCcYzsLVMk9+2buni1bd9xjMSJHMPmjCz7zov/fidW5GQ7OS/2e8BoRrLtrBfXScTIMVLsk09cJxEjZ8I6+cR1EmG1tsRaDsZ0EjlyDL0leuxOpulD4JTALtfXORRbnqVO1LDOePdtpoclWPsqulL+wt0P0SNnxFKrrp2opmuXl+5OuHA3PSmByDGQ9ezSydYdM+ELd4YUIsdANnoWTva2RSUv3JlnJRE5I2RbY+6kee1+dTrrhC7cPTZeMUdivZnydaIc3tdqqWuI6USOYZlSfp0oxzVlJxNByUSOYZlSPk6cDzqEXy17JDTn/LBMKRlTSRZ4X2giep2zZnEwZHLiGjifFt6BTtKKHMMspUxO2BkvDzoDm1jkGGa7bsaJx0t9XfgrOfuMlhezwsc48RrKufvhyiXXHatg8T2Zkm0eHzluxO8W4pXHKljkXycBt3h9blFdeqyCx2fPOguLbn6qTWsBu+Czxs/CopsdP4kmkx+mcZ8FRrfuWUqSTSYT005keDucW4iXnzRhMg17iYacC6A0VyZzzIQs0pBrUrn22JoXY4Us0pDjaZMzb+dIMX6/Qi0dHSU0XHySz48heqSaOs60vsvlq2mtpzj9OCh/Trgjew7afgLar63d6ec2SmTZm37+UyV7048K+Gmkm7O10A/8aaSbY7sEr8rYvYoNnX4Sr3EuYJVpVc35Ccu/innZbryMJ1n4v9f4N9FZ39XPZ931GYzMGH9VPHYfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADp8Q9+nG9anuOrfAAAAABJRU5ErkJggg==';
